module.exports = __webpack_public_path__ + "static/media/UROP_Screenshot.654db080.PNG";